import type { ClientOrganization } from '@DigitaleDoerfer/digitale-doerfer-api';
import { useMemo, type FC } from 'react';
import { StyleSheet, View } from 'react-native';
import { Text } from 'react-native-paper';

import { PersonIcon } from '@/assets';
import { ProfileAvatar } from '@/features/media/components/avatar/ProfileAvatar';
import { MediaItemSize } from '@/features/media/types/mediaItem';
import { useAppTheme } from '@/styles/hooks/useAppTheme';
import type { AppTheme } from '@/styles/theme';

type Props = {
  organization: ClientOrganization;
};

export const TerritorialAuthorityHeader: FC<Props> = ({ organization }) => {
  const theme = useAppTheme();
  const styles = useMemo(() => makeStyles(theme), [theme]);

  return (
    <View style={styles.header}>
      <ProfileAvatar
        viewSize={48}
        iconFallback={PersonIcon}
        mediaItem={organization.logoImage}
        mediaSize={MediaItemSize.SMALL}
      />
      <Text variant="titleLarge" numberOfLines={2} style={styles.name}>
        {organization.name}
      </Text>
    </View>
  );
};

const makeStyles = (theme: AppTheme) =>
  StyleSheet.create({
    header: {
      flexDirection: 'row',
      alignItems: 'center',
      gap: 12,
      paddingHorizontal: 16,
      paddingTop: 16
    },
    name: {
      flex: 1,
      color: theme.colors.onSurface
    }
  });
